<template>
  <div class="standard">
    <div class="inner">
      <img v-if="$store.state.user.banner.banner2" style="width:100%;" :src="$store.state.user.banner.banner2" alt="banner">
    </div>
    <div class="standard_center">
      <div class="stand_warp">
          <div class="stan_list" v-for="(item,key) in pdflist" :key="key">
              
              <div class="pdfitems" @click="paddetails(item.padopen)">
                  <img :src="item.imgop" alt="">
              </div>
              <p>{{item.titlepdf}}</p>
             
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        
      pdflist: [
      {
        imgop:require("../assets/images/dzpdf1.png"),
        titlepdf:"电子商务师",
        id:1,
        padopen:require('../assets/pdf/dzs1.pdf')
      },
      {
        imgop:require("../assets/images/dzpdf2.png"),
         titlepdf:"计算机及外部设备装配 调试员",
         id:2,
         padopen:require('../assets/pdf/dzs2.pdf')
      },
      {
        imgop:require("../assets/images/dzpdf3.png"),
         titlepdf:"计算机网络管理员",
         id:3,
         padopen:require('../assets/pdf/dzs3.pdf')
      },
      {
        imgop:require("../assets/images/dzpdf4.png"),
         titlepdf:"健康管理师",
         id:4,
         padopen:require('../assets/pdf/dzs4.pdf')
      },
      {
        imgop:require("../assets/images/dzpdf5.png"),
         titlepdf:"企业人力资源管理师 （劳务派遣管理员）",
         id:5,
         padopen:require('../assets/pdf/dzs5.pdf')
      },
      {
        imgop:require("../assets/images/dzpdf6.png"),
         titlepdf:"养老护理员",
         id:6,
         padopen:require('../assets/pdf/dzs6.pdf')
      },
       {
        imgop:require("../assets/images/dzpdf7.png"),
         titlepdf:"文物修复师",
         id:7,
         padopen:require('../assets/pdf/dzs7.pdf')
      },
      ],
    };
  },
  mounted() {},
  methods: {
      paddetails(urls){
        window.open(urls)
      }
  },
};
</script>
<style lang="scss" scoped>
.standard_center {
  width: 1280px;
  margin: 40px auto;

.stand_warp{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
   margin-left: -25px;

  .stan_list {
    width: 250px;
    min-height: 373px;
    padding: 15px 20px;
    box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
    margin:30px 0 0 65px;
    cursor: pointer;
    .pdfitems{
    background: #ffffff;
    border-radius: 10px;
    }
    p{
font-size: 18px;
font-weight: 500;
color: #333333;
margin-top: 20px;
word-break: break-all;
text-overflow: ellipsis;
overflow: hidden;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;
    }
  }
}
}
</style>
